/* eslint-disable import/no-extraneous-dependencies */
import 'react-app-polyfill/ie11.js';
import 'url-search-params-polyfill';
import 'url-polyfill';
import 'whatwg-fetch';

import React from 'react';
import ReactDOM from 'react-dom';
import { enableES5 } from 'immer';
import {
    postVerificationSizeUpdates, setOptions, LicensedProfessionalPersonalInfoViewModel, setViewModel, overrideComponent,
} from '@sheerid/jslib';

import './index.css';
import App from './App';

import { defaultOptions } from './programOptions';
import { googleTagManagerHook } from './hooks/hooks';
import { StepPendingComponent } from './components/StepPending/StepPendingComponent';
import { StepLicensedProfessionalPersonalInfoComponent } from './components/StepPersonalInfo/StepLicensedProfessionalPersonalInfoComponent';
import { StepDocUploadComponent } from './components/StepDocUpload/StepDocUploadComponent';
import { StepErrorComponent } from './components/StepError/StepErrorComponent';

const defaultViewModel: LicensedProfessionalPersonalInfoViewModel = {
    statuses: ['VETERINARIAN'],
    email: '',
    firstName: '',
    lastName: '',
    birthDate: '',
    postalCode: '',
    localeChoice: {
        value: 'en-US',
        label: 'en-US',
    },
    organization: {
        id: 0,
        name: '',
    },
    metadata: {
        marketConsentValue: false,
    },
    countryChoice: {
        value: 'US',
        label: 'en-US',
    },
};
// @ts-ignore
overrideComponent('StepPendingComponent', StepPendingComponent);
// @ts-ignore
overrideComponent('StepLicensedProfessionalPersonalInfoComponent', StepLicensedProfessionalPersonalInfoComponent);
// @ts-expect-error
overrideComponent('StepDocUploadComponent', StepDocUploadComponent);
// @ts-expect-error
overrideComponent('StepErrorComponent', StepErrorComponent);
setViewModel(defaultViewModel);
setOptions(defaultOptions);
googleTagManagerHook();
postVerificationSizeUpdates();
enableES5();

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root'),
);
